import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { Meeting } from "../model/data";
import { map } from "rxjs/operators";

@Injectable({
  providedIn: "root"
})
export class DataService {
  urldata: string = "/assets/data.json";
  urlHtml: string = "/assets/data.html";

  constructor(private http: HttpClient) {}

  getMeetings(): Observable<Array<Meeting>> {
    return this.http.get<Array<Meeting>>(this.urldata);
  }
  getLastMeeting(): Observable<Meeting> {
    return this.getMeetings().pipe(map(d => d[0]));
  }
  getHtml(): Observable<string> {
    return this.http.get(this.urlHtml,{responseType:'text'});
  }
}
